import styled from 'styled-components'

import { breakpoint } from '@sketch/global-styles'

import {
  Button,
  Text,
  WorkspaceLogo as WorkspaceLogoUnstyled,
  Panel,
  FakeLinkButton,
  SsoTag,
} from '@sketch/components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledPanel = styled(Panel)`
  width: 100%;
`

export const Header = styled(Text.Span).attrs({
  textStyle: 'copy.quaternary.standard.D',
})`
  display: inline-block;
  padding-right: 12px;
`

export const WorkspaceLineWrapper = styled.div`
  display: flex;

  :not(:last-child) {
    margin-bottom: 8px;
  }
`

export const LinkedWorkspacesAvatarsContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledWorkspaceLogo = styled(WorkspaceLogoUnstyled)`
  margin-right: 12px;
`

export const WorkspaceName = styled.span`
  flex: 1;
`

export const Description = styled(Text).attrs({
  textStyle: 'copy.primary.standard.F',
})`
  margin: 0;
  padding: 0;
  text-align: center;
`

export const StyledPanelFooter = styled(Panel.Footer)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 6px;
  padding: 0;
  text-align: center;
  background: none;
`

export const StyledFakeLinkButton = styled(FakeLinkButton)`
  display: inline-block;
  padding: 10px 12px;
  font-size: ${({ theme }) => theme.fontSizes.E};
  text-align: center;
  color: ${({ theme }) => theme.colors.buttons.secondary.color};
`

export const StyledButton = styled(Button)`
  margin-top: 32px;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 520px;
  margin: 16px auto;
  font-size: ${({ theme }) => theme.fontSizes.E};
  background-color: ${({ theme }) => theme.colors.background.secondary.A};
  border-radius: ${({ theme }) => theme.radii.large};
  padding: 34px 32px;
  box-shadow: ${({ theme }) => theme.shadows.boxShadow.panel};

  ${breakpoint('base', 'sm')`
      width: calc(100% - 24px);
      
  `}
`

export const LineTitle = styled(Text).attrs({
  textStyle: 'copy.tertiary.standard.E',
})`
  display: flex;
  align-items: flex-start;
  margin: 0;
  flex: 2;

  ${breakpoint('base', 'sm')`
    margin-bottom: 8px;
  `}
`
export const LineContent = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 3;
`

export const Line = styled.div`
  display: flex;
  justify-items: center;
  padding: 12px 16px;
  border-radius: ${({ theme }) => theme.radii.xxlarge};

  :first-child {
    ${LineContent} {
      align-items: center;
    }
  }

  ${breakpoint('base', 'sm')`
    flex-direction: column;
  `}
`

export const Name = styled.p`
  margin: 0;
  padding-left: 12px;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`

export const StyledPanelBody = styled(Panel.Body)`
  padding: 0;
`

export const StyledSsoTag = styled(SsoTag)`
  line-height: normal;
  font-size: ${({ theme }) => theme.fontSizes.E};
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

export const More = styled(FakeLinkButton)`
  margin-top: 8px;
`
